import {twMerge} from '@sdox/utils'

import {aspectRatiosClasses} from '../Media'
import {LazyImage} from '../LazyImage'
import {RichText} from '../RichText'

import type {LazyImageProps} from '../LazyImage'
import type {ReactNode} from 'react'

export interface KeyFactMediaProps {
  imageProps: LazyImageProps
  hasDivider?: boolean
}

export interface KeyFactProps {
  aspectRatio: '1/1' | '4/3' | '16/9'
  callout?: string
  cta?: ReactNode
  description?: string
  heading: string
  media: KeyFactMediaProps
}

export const KeyFact = (props: KeyFactProps) => {
  const {
    aspectRatio,
    callout,
    cta,
    description,
    heading,
    media,
  } = props

  const {className: imgClassName, ...imageProps} = media.imageProps

  const mediaClassName = twMerge(
    'w-full rounded-radius-md object-cover',
    aspectRatiosClasses[aspectRatio],
    media.hasDivider && 'border-b border-outline-secondary',
    imgClassName,
  )

  return (
    <div>
      <LazyImage
        className={mediaClassName}
        {...imageProps}
      />
      <div className={'flex flex-col items-start gap-spacing-8 self-stretch pr-spacing-16 pt-spacing-16'}>
        {callout && (
          <div className={'mb-spacing-2 text-p1 text-glyph-default-primary'}>
            {callout}
          </div>
        )}
        <RichText
          className={'text-p1-emphasized text-glyph-default-primary'}
          as={'div'}
          content={heading}
          allowedTags={['span', 'p']}
        />
        {description && (
          <div className={'mt-spacing-2 text-p1 text-glyph-default-secondary'}>
            <RichText
              content={description}
              allowedTags={['a', 'br', 'b', 'i', 'p', 'span']}
            />
          </div>
        )}
        {cta && (
          <div className={'pt-spacing-8'}>
            {cta}
          </div>
        )}
      </div>
    </div>
  )
}
